<div class="wrapper-calc">

    <input #input class="calcInput calcInputHistory" type="text" readonly />
    <input #inputResult class="calcInput calcInputResult" type="text" value="0" readonly />
    
    <div (click)="onClick($event)" data-keypress="7" class="md-button md-raised calcButton numButton numButton7" #keyPress>
        <span class="calcButtonText">7</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="8" class="md-button md-raised calcButton numButton numButton8" #keyPress>
        <span class="calcButtonText">8</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="9" class="md-button md-raised calcButton numButton numButton9" #keyPress>
        <span class="calcButtonText">9</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="/" class="md-button md-raised calcButton opButton opButtonDiv" #keyPress>
        <span class="calcButtonText">&#247;</span>
    </div>
    
    <div (click)="onClick($event)"  data-keypress="4" class="md-button md-raised calcButton numButton numButton4" #keyPress>
        <span class="calcButtonText">4</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="5" class="md-button md-raised calcButton numButton numButton5" #keyPress>
        <span class="calcButtonText">5</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="6" class="md-button md-raised calcButton numButton numButton6" #keyPress>
        <span class="calcButtonText">6</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="*" class="md-button md-raised calcButton opButton opButtonMultiply" #keyPress>
        <span class="calcButtonText">x</span>
    </div>

    <div (click)="onClick($event)"  data-keypress="1" class="md-button md-raised calcButton numButton numButton1" #keyPress>
        <span class="calcButtonText">1</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="2" class="md-button md-raised calcButton numButton numButton2" #keyPress>
        <span class="calcButtonText">2</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="3" class="md-button md-raised calcButton numButton numButton3" #keyPress>
        <span class="calcButtonText">3</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="-" class="md-button md-raised calcButton opButton opButtonSub" #keyPress>
        <span class="calcButtonText">-</span>
    </div>

    <div (click)="onClick($event)"  data-keypress="0" class="md-button md-raised calcButton numButton numButton0" #keyPress>
        <span class="calcButtonText">0</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="." class="md-button md-raised calcButton numButton numButtonDec" #keyPress>
        <span class="calcButtonText">.</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="Delete" class="md-button md-raised calcButton numButton numButtonDel" #keyPress>
        <span class="calcButtonText">AC</span>
    </div>
    <div (click)="onClick($event)"  data-keypress="+" class="md-button md-raised calcButton opButton opButtonAdd" #keyPress>
        <span class="calcButtonText">+</span>
    </div>

    <div (click)="onClick($event)"  data-keypress="Enter" class="md-button md-raised calcButton enterButton" #keyPress>
        <span class="calcButtonText">=</span>
    </div>


    <!-- keyboard only buttons -->
    <div data-keypress="Backspace" class="calcButton" style="display: none;">&larr;</div>
</div>